import styled, { css } from 'styled-components';

import {
  DefaultStyledProps,
  SUPPORTED_COMPONENTS,
  SUPPORTED_PROPERTIES,
} from '@savgroup-front-common/types';

import {
  getCustomComponentProperty,
  rem,
  styledGetCustomComponentProperty,
} from '../../../../helpers';

interface GetTextColorProps extends DefaultStyledProps {
  isError?: boolean;
  $isNewUi?: boolean;
}

const getTextColor = (props: GetTextColorProps) => {
  const { theme, $isNewUi } = props;

  if (props.isError) {
    return theme.colors.danger;
  }

  if ($isNewUi) {
    return theme.newUI.defaultColors.secondaryText;
  }

  return getCustomComponentProperty({
    theme: props.theme,
    componentName: SUPPORTED_COMPONENTS.DEFAULT_LABEL,
    property: SUPPORTED_PROPERTIES.COLOR,
    fallback: theme.colors.paragraphTextColor,
  });
};

interface LabelWrapProps {
  fullWidth?: boolean;
  isHorizontal?: boolean;
}

export const $LabelWrap = styled.div<LabelWrapProps>`
  display: flex;
  height: ${rem(24)};
  align-items: center;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'fit-content')};
  margin-bottom: ${({ isHorizontal }) => (isHorizontal ? 'unset' : '0.3rem')};
`;

interface LabelStyledProps extends DefaultStyledProps {
  isError: boolean;
  isHorizontal: boolean;
  $isNewUi?: boolean;
  $isRequired?: boolean;
  fullWidth?: boolean;
  $isMultiLine?: boolean;
}
export const $LabelStyled = styled.label<LabelStyledProps>`
  display: flex;
  align-items: center;
  font-size: ${styledGetCustomComponentProperty({
    componentName: SUPPORTED_COMPONENTS.DEFAULT_LABEL,
    property: SUPPORTED_PROPERTIES.FONT_SIZE,
  })};
  font-weight: ${styledGetCustomComponentProperty({
    componentName: SUPPORTED_COMPONENTS.DEFAULT_LABEL,
    property: SUPPORTED_PROPERTIES.FONT_WEIGHT,
  })};

  color: ${getTextColor};
  min-height: ${styledGetCustomComponentProperty({
    componentName: SUPPORTED_COMPONENTS.DEFAULT_LABEL,
    property: SUPPORTED_PROPERTIES.MIN_HEIGHT,
  })};
  margin: ${({ isHorizontal }) => (isHorizontal ? 'unset' : 0)};

  > div {
    height: 100%;
  }
  svg {
    height: ${({ theme }) => theme.fonts.size.ultraSmall};
    max-width: ${({ theme }) => theme.fonts.size.ultraSmall};
    margin-right: 0.5rem;
    color: ${({ theme }) => theme.colors.paragraphTextColor};
  }

  ${({ $isMultiLine }) => {
    if ($isMultiLine) {
      return css`
        & > * {
          white-space: normal;
        }
      `;
    }

    return css`
      & > * {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    `;
  }}

  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'inherit')};

  ${({ $isRequired }) => {
    if (!$isRequired) {
      return css``;
    }

    return css`
      &::after {
        margin-left: 0.25rem;
        content: '*';
        color: ${({ theme }) => theme.colors.danger};
      }
    `;
  }}
`;

export const $LabelContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(4)};

  margin-bottom: ${rem(8)};

  & * {
    margin: 0;
  }
`;

export const $SubLabel = styled.span`
  font-size: ${({ theme }) => theme.fonts.size.megaSmall};
  font-weight: ${({ theme }) => theme.fonts.weight.normal};
  color: ${({ theme }) => theme.newUI.defaultColors.secondaryText};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;
